import React, { useRef, useEffect, useState } from "react";
import {
  Box,
  Grid,Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Card,
  CardContent,
  IconButton
} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import PublishIcon from "@material-ui/icons/Publish";
import VisibilityIcon from "@material-ui/icons/Visibility";
import GetAppIcon from "@material-ui/icons/GetApp";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import { FormProvider, useForm } from "react-hook-form";
import DnerhsApi from "../../api/DnerhsApi";
import FormInput from "../../Controls/Input";
import FormSelect from "../../Controls/Select";
import Message from "../../Message/Message";
import { Link, useParams } from "react-router-dom";
import FormDialog from "./FormDialog/FormDialog";
import AdjuntosDialog from "../../dialogs/AdjuntosDialog";
import commonMethods from "../../utils/commonMethods";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers";
import Alert from "../../components/Alert";
import ErrorHandler from "../../components/ErrorHandler";
import { trackPromise } from 'react-promise-tracker';
import history from "../../utils/History";
import Header from "components/Header";
import { findByNumeroCedulaFechaNac } from "services/DatosPersonalesService";
import ReCAPTCHA from "react-google-recaptcha";
import FormDatePicker from "../../Controls/DatePicker";
import FormAutocomplete from "../../Controls/Autocomplete";
import AddIcon from "@material-ui/icons/Add";
import Fab from "@material-ui/core/Fab";
import NuevaInstitucionFormadoraDialog from "../../dialogs/NuevaInstitucionFormadoraDialog";
import ResponseUtils from "../../utils/ResponseUtils";
import { setFechaNacimiento } from "services/UsuarioService";
import { getFechaNacimiento } from "services/UsuarioService";

const useStyles = makeStyles((theme) => ({
  main: {
    paddingLeft: theme.spacing(16),
    paddingRight: theme.spacing(16),
  },
  appBarSpacer: theme.mixins.toolbar,
  form: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  field: {
    margin: theme.spacing(),
  },
  large: {
    width: theme.spacing(16),
    height: theme.spacing(16),
  },
  button: {
    margin: theme.spacing(2),
  },
  okButton: {
    color: "#fff",
    backgroundColor: "#01C12B",
    margin: theme.spacing(),
  },
  denyButton: {
    color: "#fff",
    backgroundColor: "#ff0000",
    margin: theme.spacing(),
  },
  title: {
    fontSize: 14,
  },
  modal: {
    position:'absolute',
    width: 400,
    backgroundColor: 'white',
    borderRadius: 5,
    borderColor: 'white',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2,4,2),
    //padding: "30px 80px 60px",
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    focus:{
      outline: 'none'
  },outline: 'none'
  },
}));

const validationSchema = yup.object().shape({
  institucion: yup.object().required("El campo institución es requerido"),
  apellidos: yup.string().required("El campo apellidos es requerido"),
  ci: yup.string().required("El campo cédula de identidad es requerido"),
  fechaNacimiento: yup.string().required("El campo fecha de nacimiento es requerido"),
  email: yup.string().email("Ingrese un email válido").required("El campo email es requerido"),
  nombres: yup.string().required("El campo nombre es requerido"),
  telefono: yup.string().required("El campo telefono es requerido"),
  aci: yup.string().required("El campo cédula de identidad es requerido"),
  anombre: yup.string().required("El campo nombres es requerido"),
  aapellido: yup.string().required("El campo apellidos es requerido"),
  cargo: yup.string().required("El campo cargo es requerido"),
  aemail: yup.string().email("Ingrese un email válido").required("El campo email es requerido"),
  atelefono: yup.string().required("El campo telefono es requerido"),
  afechaNacimiento: yup.string().required("El campo fecha de nacimiento es requerido"),
  aasignacion: yup.string().required("El campo asignación es requerido"),
});

const asignacionOptions = [
  {
    id: "Rector/a",
    label: "Rector/a",
  },
  {
    id: "Director/a General",
    label: "Director/a General",
  },
  {
    id: "Secretario/a General",
    label: "Secretario/a General",
  },
];

const Form = () => {
  
  const classes = useStyles();
  const [departamentosOptions, setdepartamentosOptions] = useState([]);
  const [ciudadOptions, setCiudadOptions] = useState([]);
  const [sent, setSent] = useState(false);
  const [sentend, setSentend] = useState(false);

  const [procesado, setProcesado] = useState(false);
  const [open, setOpen] = useState(false);
  const [idDesignacion, setIdDesignacion] = useState(null);
  const [idResponsable, setIdResponsable] = useState();
  const [observacion, setObservacion] = useState("");
  const [usuarioRevisor, setUsuarioRevisor] = useState();
  const [fechaRevision, setFechaRevision] = useState();
  const [openRechazoDialog, setOpenRechazoDialog] = useState(false);
  const [rechazada, setRechazada] = useState(false);
  const params = useParams();
  const isAddMode = !params.id;
  const methods = useForm({ resolver: yupResolver(validationSchema) });
  const { handleSubmit, errors, setValue , getValues} = methods;
  const [captchaValido, cambiarCaptchaValido] = useState(null);
	const captcha = useRef(null);
  const [documentsOptions, setDocumentsOptions] = useState({
    adjuntos: {
      tittle: "Adjuntos",
    }
  });
  const [documentSelectedKey, setDocumentSelectedKey] = useState("");
  const [institucionesList, setInstitucionesList] = useState([]);
  const [institucion, setInstitucion] = useState(null);
  const [inhabilitarNuevoIf, setInhabilitarNuevoIf] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [fechaNacAux, setFechaNacAux] = useState("");

  const captchaRef = React.createRef();
  
  // const captchaRef = useRef(null)
  const [modal2, setModal2]=useState(false);
  const [item, setItem] = useState();
 // const [captchaCargado, setCaptchaCargado] = useState(true);
  const [captchaCargado, setCaptchaCargado] = useState(false);
  const [dataForm, setDataForm] = useState(true);
  const [enlace, setEnlace] = useState(null);

  const normalizarFechaNacimiento = (value) => {
    if (!value) return "";

    if (typeof value === "string") {
      const fecha = value.trim();
      const fechaIso = fecha.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (fechaIso) {
        return `${fechaIso[1]}-${fechaIso[2]}-${fechaIso[3]}`;
      }

      const fechaPantalla = fecha.match(/^(\d{2})-(\d{2})-(\d{4})$/);
      if (fechaPantalla) {
        return `${fechaPantalla[3]}-${fechaPantalla[2]}-${fechaPantalla[1]}`;
      }
    }

    if (value && typeof value.format === "function") {
      return value.format("YYYY-MM-DD");
    }

    if (value instanceof Date && !Number.isNaN(value.getTime())) {
      const anio = value.getFullYear();
      const mes = String(value.getMonth() + 1).padStart(2, "0");
      const dia = String(value.getDate()).padStart(2, "0");
      return `${anio}-${mes}-${dia}`;
    }

    return "";
  };

  
  useEffect(() => {
    const load = () => {
      try {
        getServerData();
        if (!isAddMode) {
          setValuesForEdit();
        }
      } catch (error) {
        console.log(error);
      }
    };

    load();
  }, []);
  const showMessageError = (message) => {
    Alert.show({
      message,
      type: "error"
    })
  };
  const showServerError = (error) => {
    // Log detallado para debugging
    console.group("🚨 Error en Responsable Form");
    console.error("Error completo:", error);
    if (error.response) {
      console.error("Response status:", error.response.status);
      console.error("Response data:", error.response.data);
      console.error("Response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Request sin respuesta:", error.request);
    } else {
      console.error("Error de configuración:", error.message);
    }
    console.groupEnd();

    let message = "Ocurrió un error inesperado, por favor vuelva a reintentar";
    if (error.response) {
      message = ResponseUtils.getMessageError(error.response);
    }

    Alert.show({
      message,
      type: "error"
    })
  }

   const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleSaveDialog = async (data) => {
    handleCloseDialog();
    setSent(false);
    if(!data.captchaCargado){
      setCaptchaCargado(false);
    }else{
      setCaptchaCargado(true);
    }
    const payload =  {
        ciudad: { id: data.ciudad },
        copiaLey: "",
        departamento: {
          id: data.departamento,
        },
        direccion: data.direccion,
        email: data.email,
        institucion: data.institucion,
        ley: data.ley,
        sede: data.sede,
        telefono: data.telefono,
        tipoInstitucionFormadora:((data.tipoInstitucion===1 || data.tipoInstitucion==="1")?"Pública":"Privada"),
        asignadas:0,
        disponibles:0,
        ocupadas:0,
        logotipo: data.logotipo
    };
    try {
      let responseInstitucion;
      let nrocedula= getValues("ci");
      let fechaNacimientoResponsable = normalizarFechaNacimiento(getValues("fechaNacimiento")) || getFechaNacimiento();

      if (!fechaNacimientoResponsable) {
        Alert.show({
          message: "Ingrese la fecha de nacimiento del responsable antes de agregar la institución formadora.",
          type: "warning"
        });
        return;
      }
    
      let url =`/instituciones/formadoras/validacion/${nrocedula}/${fechaNacimientoResponsable}`;
      
      if(isAddMode){
       
        responseInstitucion = await trackPromise(DnerhsApi.post(url, {
          ...payload
        }));
        setSent(true);

        let urlListInstitucion = `/instituciones/formadoras`;   
      
        const response = await trackPromise(DnerhsApi.get(urlListInstitucion));
        setSent(true)  
        setInstitucionesList(response.data);
        const values = {
          institucion: {id: responseInstitucion.data.id, institucion:data.institucion, logotipo:data.logotipo }
        };
        const fields = [ "institucion"];

        fields.forEach((x) => setValue(x, values[x]));
        
    
      }
    
      Alert.show(
        {
          message: "Institucion creada con éxito.",
          type: "success"
        }
      )
      
    } catch(error) {
      if (error.response) {
        showServerError(error);
      } else {
        showMessageError(error);
      }
    }
    handleCloseDialog();

  }

  const setValuesForEdit = async () => {
    try {
      let url = `/instituciones/formadoras/responsables/${params.id}`;
      const response = await DnerhsApi(url);
      console.log("setValuesForEdit", response);
      const values = {
        ciudad: response.data.formadora.ciudad.id,
        departamento: response.data.formadora.departamento.id,
        direccion: response.data.formadora.direccion,
        iemail: response.data.formadora.email,
        institucion: {id: response.data.formadora.id, institucion:response.data.formadora.institucion },
        nroLeyCreacion: response.data.formadora.ley,
        sede: response.data.formadora.sede,
        itelefono: response.data.formadora.telefono,
        apellidos: response.data.responsable.apellidos,
        ci: response.data.responsable.cedulaIdentidad,
        email: response.data.responsable.email,
        nombres: response.data.responsable.nombres,
        telefono: response.data.responsable.telefono,
        aci: response.data.maximaAutoridad.cedulaIdentidad,
        anombre: response.data.maximaAutoridad.nombres,
        aapellido: response.data.maximaAutoridad.apellidos,
        cargo: response.data.maximaAutoridad.cargo,
        aemail: response.data.maximaAutoridad.email,
        atelefono: response.data.maximaAutoridad.telefono,
        atelefono: response.data.maximaAutoridad.asignacion,
      };
      const fields = [
        "ciudad",
        "departamento",
        "direccion",
        "iemail",
        "institucion",
       
     
       
        "apellidos",
        "ci",
        "email",
        "nombres",
        "telefono",
        "aci",
        "anombre",
        "aapellido",
        "cargo",
        "aemail",
        "atelefono",
        "aasignacion",
      ];

      fields.forEach((x) => setValue(x, values[x]));
      setIdResponsable(response.data.responsable.id);
      setIdDesignacion(response.data.designacionResponsable);
      setProcesado(
        response.data.estado !==
        "Solicitud pendiente de autorización por DNERHS"
      );
      setRechazada(response.data.estado === "Solicitud rechazada por DNERHS");
      setObservacion(response.data.observacion);
      setUsuarioRevisor(response.data.usuarioRevisor);
      setFechaRevision(response.data.fechaRevision);
    } catch (error) {
      console.log(error);
    }
  };

  const getServerData = async () => {
    try {
      let url = `/instituciones/formadoras`;   
      const response = await trackPromise(DnerhsApi.get(url));
      setSent(true)  
      setInstitucionesList(response.data);
      const responseDepartamentos = await DnerhsApi.get("/departamentos", {
        params: { pageSize: 100 },
      });
      const responseCiudad = await DnerhsApi.get("/departamentos/1/ciudades", {
        params: { pageSize: 100 },
      });
      setdepartamentosOptions(
        responseDepartamentos.data.map((x) => ({
          label: x.descripcion,
          id: x.id,
        }))
      );
      setCiudadOptions(
        responseCiudad.data.map((x) => ({
          label: x.descripcion,
          id: x.id,
        }))
      );
    } catch (error) {
      console.log(error);
      if (error.response) {
        Alert.showServerError(error);
      }
    }
  };
 
 

    // Función que se ejecuta al enviar el formulario
  const onSubmit = async (data) => {
    // Validación: Verifica si 'idDesignacion' tiene valor
    if (idDesignacion === null || typeof idDesignacion === 'undefined') {
      // Mostrar mensaje de error específico para documento
      ErrorHandler.handleDocumentError("documento firmado de Designación de Responsable");
      return;
    } else {
      try {
        const institucionSeleccionada = data.institucion || institucion;

        if (!institucionSeleccionada || !institucionSeleccionada.id) {
          Alert.show({
            message: "Seleccione una institución formadora antes de registrar el responsable.",
            type: "warning"
          });
          return;
        }

        // Obtener datos del responsable de la institución
        const responseData = await DnerhsApi.get(`/convenios/${institucionSeleccionada.id}/responsable-institucion`, {});

        // Si ya existe un responsable asignado
        if (responseData?.data?.responsableId > 0) {
          // Mostrar alerta informativa
          Alert.show({
            message: "La institución Formadora ya se encuentra con responsable asignado.",
            type: "warning"
          });
        } else {
          // Preparar el payload con los datos necesarios
          const payload = {
            designacionResponsable: idDesignacion,
            formadora: institucionSeleccionada,
            maximaAutoridad: {
              apellidos: getValues("aapellido"),
              cargo: getValues("cargo"),
              cedulaIdentidad: getValues("aci"),
              email: getValues("aemail"),
              nombres: getValues("anombre"),
              telefono: getValues("atelefono"),
              asignacion: getValues("aasignacion"),
            },
            responsable: {
              apellidos: getValues("apellidos"),
              cedulaIdentidad: getValues("ci"),
              email: getValues("email"),
              nombres: getValues("nombres"),
              telefono: getValues("telefono"),
            },
          };

        //console.log(payload);
          // Enviar solicitud de creación del responsable
          let url = "/instituciones/formadoras/responsables";
          await trackPromise(
            DnerhsApi.post(url, { ...payload })
          );

          // Si la solicitud es exitosa, actualizar el estado
          setSent(true);
          setSentend(true);

          // Mostrar mensaje de éxito
          Alert.show({
            message: "✅ Responsable pendiente de aprobación creado con éxito. Se enviará una notificación por email cuando sea procesado.",
            type: "success",
          });
        }
      } catch (error) {
        // Usar el manejador específico para errores de responsables
        ErrorHandler.handleResponsableError(error, "Creación de Responsable");
      }
    }
  };

  const handleBlur = (e) => {
    handleResetResponsable();
    handleFindDatosPersonales(e);
  };

  const handleBlurMaximaAutoridad = (e) => {
    handleResetMaximaAutoridad();
    handleFindDatosPersonalesMaximaAutoridad(e);
  };
  const aprobarRechazar = async (accion, motivo) => {
    try {
      let url = `/responsables/${idResponsable}/aprobacion?estado=${accion}&id=${idResponsable}&observacion=${motivo}`;

      await trackPromise(DnerhsApi.post(url));
      setSent(true)

      Alert.show({
        message: `${accion}`,
        type: "success",
      });
      history.goBack();
    } catch (error) {
      console.log(error);
      if (error.response) {
        Alert.showServerError(error);
      }
    }
  };

  const handleOpenRechazoDialog = () => {
    setOpenRechazoDialog(true);
  };

  const handleCloseRechazoDialog = (value) => {
    setOpenRechazoDialog(false);
  };

  const onAcceptRechazoDialog = (value) => {
    setOpenRechazoDialog(false);
    aprobarRechazar("Solicitud rechazada por DNERHS", value);
  };
  const handleClickOpen = () => {
    setDocumentSelectedKey("Adjuntos");
    setOpen(true);
  };
 

  const handleClose = (value) => {
    setOpen(false);
    setIdDesignacion(value);
  };

  const downloadFile = async (name) => {
    let doc = idDesignacion;
    commonMethods.downloadFile(`/file/${doc}`, `${name}_${new Date()}`, true);
  };

  const buildReportLink = (data) => {
    let queryParams = "";
    console.log("Cuerpo del reporte");
    console.log(data);
    console.log('institucion.id-------------------');
    console.log(institucion.id);
    console.log(institucion.logotipo);
    console.log('institucion.id-------------------');
    for (let [key, val] of Object.entries(data)) {
      queryParams += "&" + key + "=" + val;
    }
    return queryParams;
  };
  const buildReportObject = (data) => {
    let reportObject = {};
    reportObject["nombres"] = data["nombres"];
    reportObject["apellidos"] = data["apellidos"];
    reportObject["cedula"] = data["ci"];
    reportObject["correo"] = data["email"];
    reportObject["telefono"] = data["telefono"];
    reportObject["autoridadNombres"] = data["anombre"];
    reportObject["autoridadApellidos"] = data["aapellido"];
    reportObject["autoridadCedula"] = data["aci"];
    reportObject["autoridadCorreo"] = data["aemail"];
    reportObject["autoridadCargo"] = data["cargo"];
    reportObject["logotipo"] = institucion.logotipo;
    return reportObject;
  };
  const handleDownloadReport = async (data) => {
    let enlace = `${process.env.REACT_APP_DNERHS_REPORTES_PROTOCOL}://${process.env.REACT_APP_DNERHS_REPORTES_HOST}/?name=anexo-2`;
    let reportObject = buildReportObject(data);
    enlace += buildReportLink(reportObject);
    setEnlace(enlace);
    //  commonMethods.downloadFile(enlace, "designación.pdf", true);    
    if(captchaCargado){
      abrirCerrarModal2();
    }else{
      commonMethods.downloadFile(enlace, "designación.pdf", true);
    }
  };
  const handleFindDatosPersonales = async (event) => {
    let {target} = event;
    let fechaNacimientoNormalizada = normalizarFechaNacimiento(target.value);
    let nrocedula= getValues("ci");
    setFechaNacAux(fechaNacimientoNormalizada);
    if(fechaNacimientoNormalizada){
    setFechaNacimiento(fechaNacimientoNormalizada);

    }
    if ((fechaNacimientoNormalizada!=null && typeof(fechaNacimientoNormalizada) != 'undefined' && fechaNacimientoNormalizada!="") && (nrocedula!=null && typeof(nrocedula) != 'undefined'  && nrocedula!="")) {

      try {
      const { data } = await trackPromise(findByNumeroCedulaFechaNac(nrocedula, fechaNacimientoNormalizada));
      setSent(true)

      if (data.numeroCedula!=null && typeof(data.numeroCedula) != 'undefined') {
        setValue("nombres", data.nombres);
        setValue("apellidos", data.apellidos);
              

        // Asume que data.fechaNacimiento es una cadena en formato ISO como '2024-12-11'
        let fechaOriginal = new Date(data.fechaNacimiento); // Convierte la fecha a un objeto Date

        // Suma un día a la fecha
        fechaOriginal.setDate(fechaOriginal.getDate() );

        // Formatea la fecha nuevamente en formato ISO (o el formato que necesites)
        let nuevaFecha = fechaOriginal.toISOString().split('T')[0]; // 'YYYY-MM-DD'

        // Establece el valor en el campo
        setValue("fechaNacimiento", nuevaFecha);


       // setValue("fechaNacimiento", data.fechaNacimiento);
       
        setInhabilitarNuevoIf(false);
      }else{
        setValue("nombres","");
        setValue("apellidos", "");
        setInhabilitarNuevoIf(true);
        Alert.show({
          message: `Los datos no coinciden, datos incorrectos. Por favor intente nuevamente.`,
          type: "warning",
        });
      }
      } catch (error) {
        setValue("nombres","");
        setValue("apellidos", "");
        setInhabilitarNuevoIf(true);
        showServerError(error);
      }
    }
  }
  const handleResetResponsable = () => {   
        setValue("nombres","");
        setValue("apellidos", "");
        setValue("fechaNacimiento", null);
        setInhabilitarNuevoIf(true);
  }
  const handleResetMaximaAutoridad = () => {   
    setValue("anombre","");
    setValue("aapellido", "");
    setValue("afechaNacimiento", null);
}
  const handleFindDatosPersonalesMaximaAutoridad = async (event) => {
    let {target} = event;
    let fechaNacimientoNormalizada = normalizarFechaNacimiento(target.value);
    let nrocedula= getValues("aci");
    if ((fechaNacimientoNormalizada!=null && typeof(fechaNacimientoNormalizada) != 'undefined' && fechaNacimientoNormalizada!="") && (nrocedula!=null && typeof(nrocedula) != 'undefined'  && nrocedula!="")) {
       try {
       const { data } = await trackPromise(findByNumeroCedulaFechaNac(nrocedula, fechaNacimientoNormalizada));
      setSent(true)
        // Asume que data.fechaNacimiento es una cadena en formato ISO como '2024-12-11'
        let fechaOriginal = new Date(data.fechaNacimiento); // Convierte la fecha a un objeto Date

        // Suma un día a la fecha
        fechaOriginal.setDate(fechaOriginal.getDate() );

        // Formatea la fecha nuevamente en formato ISO (o el formato que necesites)
        let nuevaFecha = fechaOriginal.toISOString().split('T')[0]; // 'YYYY-MM-DD'

        // Establece el valor en el campo
       
     

      if (data.numeroCedula!=null) {
        setValue("anombre", data.nombres);
        setValue("aapellido", data.apellidos);
        setValue("afechaNacimiento", nuevaFecha);
     
      }else{
        setValue("anombre","");
        setValue("aapellido", "");
        Alert.show({
          message: `Los datos no coinciden, datos incorrectos. Por favor intente nuevamente.`,
          type: "warning",
        });
      }
      } catch (error) {
        setValue("anombre","");
        setValue("aapellido", "");
        showServerError(error);
      }
    }
  }
  const abrirCerrarModal2 =()=>{
    setModal2(!modal2);     
  }
    const cerrarModal2 =()=>{
    setModal2(!modal2);     
  }
  const getOptionsInstitucionesList = (institucion) => {
    setInstitucion(institucion);
    return `${institucion?.institucion}`;
   }
   const onChange = () => {
    console.log("Hubo un cambio");
    console.log(captchaRef.current.getValue());
    if(captchaRef.current.getValue()){
     console.log("El usuario no es un robot!!!");     
     cerrarModal2();
     commonMethods.downloadFile(enlace, "designación.pdf", true);         
    }
   }
  const bodyModal2= (
  
    <div className={classes.modal} align="center" classes={{focused: classes.outlinedInputFocused}} 
    style={{fontSize: 0.875+'rem', fontFamily: 'Roboto', fontWeight: 400,
    lineHeight: 1.43,
    letterSpacing: 0.01071+'em'
  }} >
        <Card >
           {/* Comentamos el ReCAPTCHA temporalmente */}
        {/*
        <ReCAPTCHA
        ref={captchaRef}
        
     //   sitekey="6LcHohopAAAAAEglVfXf_DUn2hye3GkcbHnl5PA1"
        sitekey="6Lefd0kqAAAAAAhIVvfr-woIwH2S0_dDYPxQsDBa"

      
        
        // sitekey="6LevdaojAAAAAGY4Wgo-dfiGTqxfkWE4YGAS6eIJ"
        onChange={onChange}
                           /> 
                            */}
          <Grid container direction="row" justifyContent="flex-end" alignItems="center">
        
           
            <Grid item className={classes.field}>
              <Button
                variant="contained"
                color="default"
                onClick={()=>cerrarModal2()}>Cancelar
              </Button>
            </Grid>
            
          </Grid>
      </Card>
    </div>
    
  );
  
  

  return !sentend ? (
    <>
      {isAddMode && <Header />}
      <div className={classes.appBarSpacer}>
        <div className={classes.main}>
          
          <Grid item xs={12}>
            {isAddMode ? (
              <Typography
                align="center"
                variant="h5"
                color="primary"
                className={classes.form}
              >
                Registro de responsable de institución formadora
              </Typography>
            ) : (
              <Typography
                align="center"
                variant="h5"
                color="primary"
                className={classes.form}
              >
                Revisión solicitud nuevo usuario
              </Typography>
            )}
          </Grid>
          <div>
            <FormProvider {...methods}>
              <Paper>
                <form>
                  <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="flex-start"
                  >
                    <Grid item xs={12} className={classes.field}>
                      <Typography align="center" variant="h6" color="primary">
                        Datos del Responsable
                      </Typography>
                    </Grid>
                    
                   
                    <Grid item xs={6} className={classes.form}>               
                      <Grid item xs={12} className={classes.field} >
                        <FormInput
                          name="ci"
                          label="Cédula de Identidad"
                          errorobj={errors}
                          required
                          disabled={!isAddMode}
                        />
                      </Grid>
                     
                      <Grid item xs={12} className={classes.field}>
                        <FormInput
                          name="nombres"
                          label="Nombres"
                          errorobj={errors}
                          required
                          disabled={true}
                        />
                      </Grid>
                      <Grid item xs={12} className={classes.field}>
                        <FormInput
                          name="telefono"
                          label="Teléfono"
                          errorobj={errors}
                          required
                          disabled={!isAddMode}
                        />
                      </Grid>
                    </Grid>
                  
                    <Grid item xs={6} className={classes.form}>
                    <Grid item xs={12} className={classes.field}  onBlur={handleBlur} >
                        <FormDatePicker 
                          name="fechaNacimiento" 
                          label="Fecha de Nacimiento"                  
                          errorobj={errors}
                          required
                          disabled={!isAddMode}
                        />                          
                      </Grid>
                      
                      <Grid item xs={12} className={classes.field}>
                        <FormInput
                          name="apellidos"
                          label="Apellidos"
                          errorobj={errors}
                          required
                          disabled={true}
                        />
                      </Grid>
                     
                      <Grid item xs={12} className={classes.field}>
                        <FormInput
                          name="email"
                          label="E-mail"
                          errorobj={errors}
                          required
                          disabled={!isAddMode}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="flex-start"
                    >
                      <Grid item xs={12} className={classes.field}>
                        <Typography align="center" variant="h6" color="primary">
                          Datos de la Institución Formadora
                        </Typography>
                      </Grid>
                      
                      <Grid item xs={9} className={classes.form}  
                      container
                      direction="row"
                      justifyContent="flex-end"
                      alignItems="center" >
                        <Grid item xs={6} className={classes.field}>
                          <FormAutocomplete   
                            name="institucion"                   
                            options={institucionesList}
                            getOptionLabel={getOptionsInstitucionesList}
                            getOptionSelected={(option, value) =>
                              option.id === value.id
                            }
                            label="Institución Formadora"
                            disabled={!isAddMode}
                            required
                            errorobj={errors}                             
                            
                          />
                        </Grid>
                       
                        <Grid item xs={3} className={classes.field}>
                          <Button
                            variant="contained"
                            color="primary"
                            disabled={inhabilitarNuevoIf}
                            onClick={() =>  handleOpenDialog()}
                          >
                            Agregar institución formadora
                          </Button>
                        </Grid>
                      </Grid>
                      
                    </Grid>
                      
                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="flex-start"
                    >
                      <Grid item xs={12} className={classes.field}>
                        <Typography align="center" variant="h6" color="primary">
                          Datos de la Máxima Autoridad de la Institución
                          Formadora
                        </Typography>
                      </Grid>


                      <Grid item xs={6} className={classes.form}>
                        <Grid item xs={12} className={classes.field} >
                          <FormInput
                            name="aci"
                            label="Cedula de Identidad"
                            disabled={!isAddMode}
                            errorobj={errors}
                            required
                          />
                        </Grid>
                        <Grid item xs={12} className={classes.field}>
                          <FormInput
                            name="anombre"
                            label="Nombres"
                            disabled={true}
                            errorobj={errors}
                            required
                          />
                                           
                        </Grid>
                      <Grid item xs={12} className={classes.field}>
                          <FormInput
                            name="cargo"
                            label="Cargo"
                            //options={cargoOptions}
                            disabled={!isAddMode}
                            errorobj={errors}
                            required
                          />
                        </Grid>
                        <Grid item xs={12} className={classes.field}>
                          <FormInput
                            name="aemail"
                            label="E-mail"
                            disabled={!isAddMode}
                            errorobj={errors}
                            required
                          />
                        </Grid>
                      </Grid>
                      <Grid item xs={6} className={classes.form} onBlur={handleBlurMaximaAutoridad}>
                        <Grid item xs={12} className={classes.field}  >
                          <FormDatePicker 
                            name="afechaNacimiento" 
                            label="Fecha de Nacimiento"                  
                        //    disabled={true}
                            errorobj={errors}
                            required
                          />
                        </Grid>
                        <Grid item xs={12} className={classes.field}>
                          <FormInput
                            name="aapellido"
                            label="Apellidos"
                            disabled={true}
                            errorobj={errors}
                            required
                          />
                        </Grid>
                       
                        <Grid item xs={12} className={classes.field}>
                          <FormInput
                            name="atelefono"
                            label="Teléfono"
                            disabled={!isAddMode}
                            errorobj={errors}
                            required
                          />
                        </Grid>

                        <Grid item xs={12} className={classes.field}>
                          <FormSelect
                            name="aasignacion"
                            label="Asignación"
                            options={asignacionOptions}
                            disabled={!isAddMode}
                            errorobj={errors} required
                          />
                        </Grid>

                      </Grid>
                    </Grid>
                 
                 
                  </Grid>
               
                </form>
              </Paper>
            </FormProvider>
          </div>
          <Grid container className={classes.form}>
            <Grid item xs={12}>
              <Paper>
                <Box p={1}>
                  <Typography
                    variant="h5"
                    color="primary"
                    align="center"
                    className={classes.title}
                  >
                    Adjuntos
                  </Typography>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell align="left">Documento</TableCell>
                        <TableCell align="center">Acciones</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                  
                      <TableRow key={"Adjuntos"}>
                        <TableCell align="left">
                          Designación de Responsable de la Gestión (firmado
                          digitalmente)
                        </TableCell>
                        <TableCell align="center">
                       
                          {isAddMode && (
                            <Button
                              variant="contained"
                              color="primary"
                              size="small"
                              className={classes.button}
                              startIcon={<GetAppIcon />}
                              onClick= {handleSubmit(handleDownloadReport)}
                              >
                              Descargar documento para firma
                            </Button>
                          )}
                          {isAddMode && (
                            <Button
                              variant="contained"
                              color="primary"
                              size="small"
                              className={classes.button}
                              onClick={() => handleClickOpen()}
                              startIcon={<PublishIcon />}
                            >
                              Subir documento firmado
                            </Button>
                          )}
                          {!isAddMode && (
                            <Tooltip title="Ver" aria-label="ver">
                              <>
                                <IconButton
                                  size="small"
                                  aria-label="ver"
                                  color="secondary"
                                  disabled={!idDesignacion}
                                  onClick={() =>
                                    downloadFile(
                                      "Designación de Responsable de la Gestión"
                                    )
                                  }
                                >
                                  <VisibilityIcon />
                                </IconButton>
                              </>
                            </Tooltip>
                          )}
                        </TableCell>
                      </TableRow>
                      
                    </TableBody>
                  </Table>
                </Box>
              </Paper>
            </Grid>
          </Grid>
          {rechazada && (
            <Card className={classes.root} variant="outlined">
              <CardContent>
                <Typography variant="h5" color="primary">
                  Motivo del rechazo
                </Typography>
                <Typography className={classes.pos} color="primary">
                  {observacion}
                </Typography>
                <Typography variant="body2" component="p">
                  Rechazado por: {usuarioRevisor}
                </Typography>
                <Typography variant="body2" component="p">
                  Fecha: {fechaRevision}
                </Typography>
              </CardContent>
            </Card>
          )}
          {isAddMode ? (
            <Grid
              item
              container
              justifyContent="flex-end"
              alignItems="center"
              className={classes.form}
            >
              <Grid item className={classes.field}>
                <Button
                  variant="contained"
                  color="default"
                  component={Link}
                  to={`/login`}
                >
                  Atrás
                </Button>
              </Grid>

              <Grid item className={classes.field}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit(onSubmit)}
                >
                  Registrarse
                </Button>
              </Grid>
            </Grid>
          ) : !procesado ? (
            <Grid
              container
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              className={classes.form}
            >
              <Grid item className={classes.field}>
                <Button
                  variant="contained"
                  color="default"
                  component={Link}
                  to={`/responsables`}
                >
                  Atrás
                </Button>
              </Grid>
              <Grid item className={classes.field}>
                <Button
                  color="secondary"
                  variant="contained"
                  onClick={() => handleOpenRechazoDialog()}
                >
                  Rechazar
                </Button>
              </Grid>
              <Grid item className={classes.field}>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() =>
                    aprobarRechazar("Solicitud aprobada por DNERHS")
                  }
                >
                  Aprobar
                </Button>
              </Grid>
            </Grid>
          ) : (
            <Grid item container justifyContent="flex-end" alignItems="center">
              <Button
                variant="contained"
                color="default"
                component={Link}
                to={`/responsables`}
              >
                Atrás
              </Button>
            </Grid>
          )}
          <FormDialog
            open={openRechazoDialog}
            onClose={handleCloseRechazoDialog}
            onAccept={onAcceptRechazoDialog}
            aria-labelledby="form-dialog-title"
          />
          <AdjuntosDialog
            open={open}
            onClose={handleClose}
            tipoDoc="Designación responsable"
            aria-labelledby="form-dialog-title"
          />
            <NuevaInstitucionFormadoraDialog
            fechaNacAux={fechaNacAux}
            open={openDialog}
            onSave={handleSaveDialog}
            onClose={handleCloseDialog}
            aria-labelledby="form-dialog-title"
          />
<Modal backdrop="static"
        open={modal2} variant="standard"
        InputProps={{
                disableUnderline: true,
              }}
              style={{outline: 'none'}}
              classes={{focused: classes.outlinedInputFocused}}
      >
      
        {bodyModal2}
      </Modal>
        </div>
       
      </div>
     
    </>
    
  ) : (
    <>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <Grid>
          <Grid item xs={12}>
            <Message
              title="Registro de nuevo usuario enviado a la DNERHS"
              message="Aguarde la aprobación de la DNERHS para acceder al sistema. 
        Será notificado por correo en caso de aprobarse o rechazarse la solicitud."
            />
          </Grid>
          <Grid item container justifyContent="center" xs={12}>
            <Button
              variant="contained"
              size="large"
              color="primary"
              component={Link}
              to={`/login`}
            >
              Volver al login
            </Button>
          </Grid>
        </Grid>
      </Grid>
      
    </>
    
  );
};

export default Form;
